import { gql } from '@grandvisionhq/graphql';
import { returnsLineItemsFragment } from './line-item.js';
import { returnInfoFragment } from './return-info.js';

const returnFragment = gql`
  fragment ReturnFragment on Return {
    order {
      orderNumber
      lineItems {
        ...ReturnsLineItemsFragment
      }
      returnInfo {
        ...ReturnInfoFragment
      }
    }
    returnLabelUrl
    status
  }
  ${returnInfoFragment}
  ${returnsLineItemsFragment}
`;
const returnFragmentForLogin = gql`
  fragment ReturnFragmentForLogin on Return {
    status
  }
`;

export { returnFragment, returnFragmentForLogin };
//# sourceMappingURL=return.js.map
